




























import { Component, Vue, Inject, Ref, Watch } from 'vue-property-decorator';

import VeicoloList from './VeicoloList.vue';
import EditVeicolo from './veicolo/EditVeicolo.vue';
import { CrudService } from '@/data/services/crud.service';
import { Veicolo } from '@/data/models/veicolo.model';
import VeicoloFilter from './VeicoloFilter.vue';
import { Search } from '@/data/models/search.model';
import store, { State } from '@/store';
import { BModalComponent } from 'buefy/types/components';

@Component({
	components: {
		VeicoloList,
		EditVeicolo,
		VeicoloFilter,
	},
})
export default class Veicoli extends Vue {
	@Inject('CrudService') crudService!: CrudService<Veicolo>;

	@Ref('list') list!: VeicoloList;
	@Ref('filter') filter!: VeicoloFilter;

	state!: State;

	constructor() {
		super();
		this.state = store;
	}

	@Watch('state.headquarter', { deep: true })
	onHQChange() {
		this.filter.reset();
	}

	mounted() {
		this.filter.search();
	}

	onSearch(event: Search) {
		this.list.advancedSearch = event;
		this.list.loadVeicoli();
	}

	saveVeicolo(value: Veicolo, modal: BModalComponent) {

		value.hqid = this.state.headquarter!.id;
		
		this.crudService
			.createEntity(Veicolo, 'vehicle', value)
			.then(() => {
				this.list.loadVeicoli();
				this.$buefy.notification.open({
					message: this.$t('success-save') as string,
					type: 'is-success',
				});
				modal.close();
			})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			});
	}

	addVeicolo() {
		const modal = this.$buefy.modal.open({
			parent: this,
			component: EditVeicolo,
			hasModalCard: true,
			canCancel: false,
			events: {
				submit: (value: Veicolo) => {
					this.saveVeicolo(value, modal);
				},
			},
		});
	}

	editVeicolo(item: Veicolo) {
		this.openVeicolo(item);
	}

	openVeicolo(item: Veicolo) {
		const modal = this.$buefy.modal.open({
			parent: this,
			component: EditVeicolo,
			props: {
				veicolo: item,
			},
			hasModalCard: true,
			canCancel: false,
			events: {
				submit: (value: Veicolo) => {
					this.saveVeicolo(value, modal);
				},
			},
		});
	}

	deleteVeicolo(item: Veicolo) {
		this.$buefy.dialog.confirm({
			message: this.$t('warning-veicolo-delete') as string,
			type: 'is-danger',
			hasIcon: true,
			cancelText: this.$t('annulla') as string,
			onConfirm: () => {
				this.crudService
					.deleteEntity(Veicolo, 'vehicle', item)
					.then(() => {
						this.$buefy.notification.open({
							message: this.$t('success-save') as string,
							type: 'is-success',
						});
						this.list.loadVeicoli();
					})
					.catch((error) => {
						this.$buefy.notification.open({
							message: error.msg,
							type: 'is-danger',
						});
					});
			},
		});
	}

}
